module.exports = __webpack_public_path__ + "img/2.3881331f.png";